import { useQuery } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { bonusAdminBody } from "./bonusAdminBody";
import type {
  DynamicBonusArchivedStatus,
  SeriesOut,
} from "../../components/Promotions/DynamicBonuses/types";

type StoredToken = { AccessToken?: string };

async function fetchSeries(
  status?: DynamicBonusArchivedStatus,
): Promise<SeriesOut[]> {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);
  const response = status
    ? await instance.get(API_ROUTES.LIST_DYNAMIC_BONUS_SERIES, {
        params: { status },
      })
    : await instance.get(API_ROUTES.LIST_DYNAMIC_BONUS_SERIES);
  return bonusAdminBody<SeriesOut[]>(response) ?? [];
}

export const LIST_SERIES_QUERY_KEY = ["LIST_DYNAMIC_BONUS_SERIES"] as const;

/**
 * `enabled` (default `true`) lets callers gate the network request itself —
 * e.g. `CampaignsPage` only wants series rows once `dynamicBonusesExternal`
 * is on, and the backend fails closed (403) on this endpoint while the flag
 * is off, so skipping the request avoids a guaranteed-failing call.
 */
export const useListSeries = (
  enabled = true,
  status?: DynamicBonusArchivedStatus,
) => {
  return useQuery<SeriesOut[]>({
    queryKey: [...LIST_SERIES_QUERY_KEY, status ?? "all"],
    queryFn: () => fetchSeries(status),
    enabled,
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};
